import * as Yup from "yup";
import { LABELS, NAMES } from "./Config";

let { NAME, DEGREE, STATUS, LICENSE, ABOUT_AUTHOR, AUTHOR_IMAGE } = LABELS;

export const VALIDATION_SCHEMA = Yup.object({
    [NAMES[NAME]]: Yup.string()
        .required("Please enter the Name")
        .max(255, "Maximum 255 characters allowed"),
    [NAMES[STATUS]]: Yup.string()
        .required("Please select Status")
        .max(255, "Maximum 255 characters allowed"),
    [NAMES[DEGREE]]: Yup.string()
        .required("Please enter Degree")
        .max(255, "Maximum 255 characters allowed"),
    [NAMES[LICENSE]]: Yup.string()
        .required("Please enter License")
        .max(255, "Maximum 255 characters allowed"),
    [NAMES[ABOUT_AUTHOR]]: Yup.string()
        .required("Please Enter Details")
        .max(255, "Maximum 255 characters allowed"),
    [NAMES[AUTHOR_IMAGE]]: Yup.mixed().required("Image is required")
});

export const NARRATOR_VALIDATION_SCHEMA = Yup.object({
    [NAMES[NAME]]: Yup.string()
        .required("Please enter the Name")
        .max(255, "Maximum 255 characters allowed"),
    [NAMES[STATUS]]: Yup.string()
        .required("Please select Status")
        .max(255, "Maximum 255 characters allowed")
});
